import { paginatedTransform } from 'src/services/skuit/utils'
import { BatchSku, PaginatedResponse } from 'src/api/models'

import { API, CustomAxiosConfig } from './types'

export class BatchSkusAPI {
  api: API

  constructor(api: API) {
    this.api = api
  }

  list = async (config: CustomAxiosConfig = {}): Promise<PaginatedResponse<BatchSku>> => {
    const response = await this.api.get('/logistics/batch-skus', config)
    return paginatedTransform(BatchSku)(response.data)
  }
}
